var swiperArray = [];
jQuery(document).ready(function($) {

    $('.swiper-wrapper').each(function(index){

        $(this).children().each(function(){
            $(this).addClass('swiper-slide');
        });

        var origin = $(this).parent();
        var section = origin.closest('.shopify-section');
        section.addClass('slideshow-' + index);

        if (origin.hasClass('homeSlider__sliderWrapper')){
            var slidesPerView = parseInt(origin.closest('.homeSlider').data('slides-to-show'));
            console.log(slidesPerView);
            var config = {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                navigation: {
                    nextEl: '.slideshow-' + index + ' .homeSlider__arrow--next',
                    prevEl: '.slideshow-' + index + ' .homeSlider__arrow--previous',
                },
                scrollbar: {
                    el: '.slideshow-' + index + ' .homeSlider__barWrapper',
                    draggable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: Math.ceil(slidesPerView / 2),
                        spaceBetween: 25
                    },
                    1024: {
                        slidesPerView: slidesPerView,
                        spaceBetween: 25
                    }
                }
            }
            swiperArray.push(new Swiper('.slideshow-' + index + ' .homeSlider__sliderWrapper', config));
        }
        /*
        else if (origin.hasClass('slideshow--pdpThumbs')){
            var config = {
                slidesPerView: 4,
                spaceBetween: 10,
                loop: false,
                direction: 'horizontal',
                breakpoints: {
                    1000: {
                        direction: 'vertical'
                    }
                }
            }
            swiperArray.push(new Swiper('.slideshow-' + index + ' .slideshow--pdpThumbs', config));
        }
        */
        else{
            console.log('make sure your slideshow is set up correctly');
        }
    });
    console.log(swiperArray);
});
